import styled from 'styled-components';

const WeekSelectionWrapper = styled.h4`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 0rem;
  align-items: center;

  > span {
    background: none;
    border: none;
    display: inline-block;
    cursor: pointer;
    vertical-align: top;
    margin-bottom: 1rem;
    user-select: none;

    svg {
      transition: color .15s ease;
      font-size: 1.45em;
    }

    :focus {
      outline: 0;
    }

    :hover {
      svg { 
        color: #747474;
      }
    }

    :first-of-type {
      padding: 1px 6px 1px 1px !important;

      svg {
        margin-left: 0 !important;
        margin-right: 0.5rem !important;
      }

      @media only screen and (max-width: 1199px) {
        padding: 1px 6px 1px 3px !important;
        svg {
          margin-right: 0.15rem !important;
        }
      }

      @media only screen and (max-width: 550px) {
        margin-bottom: .75rem !important;
        padding: 1px 0px 1px 45px !important;    
        svg {
          font-size: 1.75em !important;
        }
      }
    }

    :last-of-type {
      padding: 1px 1px 1px 6px !important;

      svg {
        margin-left: 0.5rem !important;
        margin-right: 0 !important;
      }

      @media only screen and (max-width: 1199px) {
        padding: 1px 3px 1px 6px !important;
        svg {
          margin-left: 0.15rem !important;
        }
      }

      @media only screen and (max-width: 550px) {
        margin-bottom: .75rem !important;
        padding: 1px 45px 1px 0px !important;    
        svg {
          font-size: 1.75em !important;
        }
      }
    }
  }
`;

const DateTitleParagraph = styled.p`
  display: inline-block;
  font-weight: 600;
  text-align: center;
  font-size: 28px;
  margin-bottom: 1rem;
  margin-right: auto;
  margin-left: auto;
  text-rendering: optimizeLegibility;

  @media only screen and (max-width: 1199px) and (min-width: 551px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 550px) {
    font-size: 16px;
    margin-bottom: .75rem;
  }
`

export {
  DateTitleParagraph,
  WeekSelectionWrapper,
};
